import { render, staticRenderFns } from "./ChargerIcon.vue?vue&type=template&id=4d2854f8&"
import script from "./ChargerIcon.vue?vue&type=script&lang=js&"
export * from "./ChargerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports